var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    enableBackground: "new 0 0 283.46 283.46",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M223.14,177.72v87.93c0,4.7-3.81,8.5-8.5,8.5H37.6 c-4.7,0-8.5-3.81-8.5-8.5V38.58c0-4.7,3.81-8.5,8.5-8.5h177.03c4.7,0,8.5,3.81,8.5,8.5v79.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M223.14,177.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M223.14,118.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6300FF",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    d: "M80.93,217.4H74.8c-0.78,0-1.42-0.63-1.42-1.42v-6.13 c0-0.78,0.63-1.42,1.42-1.42h6.13c0.78,0,1.42,0.63,1.42,1.42v6.13C82.35,216.77,81.71,217.4,80.93,217.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6300FF",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    d: "M80.93,161.19H74.8c-0.78,0-1.42-0.63-1.42-1.42v-6.13 c0-0.78,0.63-1.42,1.42-1.42h6.13c0.78,0,1.42,0.63,1.42,1.42v6.13C82.35,160.56,81.71,161.19,80.93,161.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M57.44,94.75l13.95,20.63 c1.14,1.68,3.62,1.66,4.72-0.04l28.31-43.4"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 124.16,
    y1: 99.5,
    x2: 193.95,
    y2: 99.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M191,156.71"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 124.16,
    y1: 156.71,
    x2: 191,
    y2: 156.71
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M193.95,212.92"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M154.67,212.92"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 124.16,
    y1: 212.92,
    x2: 151.17,
    y2: 212.92
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6300FF",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M160.45,39.95H92.22 c-3.6,0-6.29-3-5.55-6.19l4.77-20.38C92,11,94.32,9.31,96.99,9.31h58.68c2.68,0,4.99,1.7,5.55,4.07l4.77,20.38 C166.74,36.94,164.05,39.95,160.45,39.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M146.55,248.13l41.65-24.23l76.37-96.67 l-29.89-23.61l-76.69,97.07l-13.63,45.72C143.98,247.7,145.38,248.81,146.55,248.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M238.42,98.88c5.84-7.39,17.26-8.09,25.51-1.57 c8.25,6.52,10.21,17.8,4.38,25.18"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 223.28,
    y1: 118.04,
    x2: 253.17,
    y2: 141.66
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 185.09,
    y1: 220.48,
    x2: 155.09,
    y2: 196.78
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 146.6,
    y1: 231,
    x2: 161.03,
    y2: 242.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/Review.44dba448aa348188807f56afd6abb048.svg";
export { ForwardRef as ReactComponent };